import React from "react";

import styles from "./PracticeHeader.module.css";

const PracticeHeader = (props) => {
    const specialtiesText = props.practice.specialties.map(specialty => specialty.name).join(", ");

    return (
        <div className={styles.practiceHeader}>
            <h1>{props.practice.practice_name}</h1>
            <h2>{specialtiesText}</h2>
        </div>
    );
}

export default PracticeHeader;